// eslint-disable-next-line react/prop-types
import { Link } from "react-router-dom";
import { logoSmallWhite } from "../_components/Imagepath";

const Header = (props) => {
  const handlesidebar = () => {
    document.body.classList.toggle("mini-sidebar");
  };

  const user = window.CURRENT_USER;
  const company = window.COMPANY;

  const onMenuClik = () => {
    // eslint-disable-next-line react/prop-types
    props.onMenuClick();
  };

  return (
    <div className="header header-one">
      <Link
        to="/dashboard/"
        className="d-inline-flex d-sm-inline-flex align-items-center d-md-inline-flex d-lg-none align-items-center device-logo"
      >
        <img
          src={company?.company_icon}
          className="img-fluid logo2"
          alt="Logo"
          width={'50px'}
        />
      </Link>
      <div className="main-logo d-inline float-start d-lg-flex align-items-center d-none d-sm-none d-md-none">
        <div className="logo-white">
          <Link to="/dashboard/">
            <img
              src={company?.company_icon}
              className="img-fluid logo-blue"
              alt="Logo"
              style={{
                width: "50px",
              }}
            />
          </Link>
          <Link to="index">
            <img
              src={logoSmallWhite}
              className="img-fluid logo-small"
              alt="Logo"
            />
          </Link>
        </div>
        <div className="logo-color">
          <Link to="index">
            {/* <img src={logo} className="img-fluid logo-blue" alt="Logo" /> */}
          </Link>
          <Link to="index">
            {/* <img src={logoSmall} className="img-fluid logo-small" alt="Logo" /> */}
          </Link>
        </div>
      </div>
      {/* Sidebar Toggle */}
      <Link to="#" id="toggle_btn" onClick={handlesidebar}>
        <span className="toggle-bars">
          <span className="bar-icons" />
          <span className="bar-icons" />
          <span className="bar-icons" />
          <span className="bar-icons" />
        </span>
      </Link>
      <Link
        to="#"
        className="mobile_btn"
        id="mobile_btn"
        onClick={() => onMenuClik()}
      >
        <i className="fas fa-bars" />
      </Link>
      <ul className="nav nav-tabs user-menu">
        <li className="nav-item  has-arrow dropdown-heads "></li>
        {/* User Menu */}
        <li className="nav-item dropdown">
          <Link
            to="/accounts/settings/"
            className="user-link  nav-link"
            // data-bs-toggle="dropdown"
          >
            <span className="user-content">
              <span className="user-name">{user?.name}</span>
              <span className="user-details">{user?.username}</span>
            </span>
          </Link>
        </li>
        {/* /User Menu */}
      </ul>
      {/* /Header Menu */}
    </div>
  );
};
export default Header;
